export enum EElementType {
  Node = 'node',
  Section = 'section',
  Row = 'row',
}
